import type { HTMLAttributes } from "react";

import {
  GRID_GAP_CLASS_MAP,
  GRID_RESPONSIVE_GAP_CLASS_MAP,
} from "@/ui/components/layout/Grid";
import type {
  BreakpointProp,
  DefinedDefaults,
  TWithDataComponent,
} from "@/ui/lib";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_INLINE_TAGS = [ "div", "ul", "ol", "article" ] as const;

export const INLINE_GAP_CLASS_MAP = GRID_GAP_CLASS_MAP;

export const INLINE_RESPONSIVE_GAP_CLASS_MAP = GRID_RESPONSIVE_GAP_CLASS_MAP;

export const INLINE_ALIGN_CLASS_MAP = {
  default: "",
  center: "items-center",
};

export const INLINE_JUSTIFY_CLASS_MAP = {
  default: "",
  between: "justify-between",
};

/*-------------------------------------
|  Types
|-------------------------------------*/

type TInlineTag = typeof AVAILABLE_INLINE_TAGS[number];

export type TInlineGap = keyof typeof INLINE_GAP_CLASS_MAP;

export type TInlineGapProp =
  BreakpointProp<typeof INLINE_RESPONSIVE_GAP_CLASS_MAP>;

export type TInlineAlign = keyof typeof INLINE_ALIGN_CLASS_MAP;
export type TInlineJustify = keyof typeof INLINE_JUSTIFY_CLASS_MAP;

export type TInlineProps = {
  tag?: TInlineTag;
  gap?: TInlineGapProp;
  align?: TInlineAlign;
  justify?: TInlineJustify;
} & TWithDataComponent & HTMLAttributes<HTMLElement>;

type TInlineDefaultProps = DefinedDefaults<
  TInlineProps,
  "data-component" | "gap" | "tag" | "align" | "justify"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const INLINE_DEFAULTS = {
  tag: "div",
  gap: "4",
  "data-component": "Inline",
  align: "default",
  justify: "default",
} satisfies TInlineDefaultProps;
